import type {
  LocationSelectParentOptionItemData,
  LocationSelectParentOptionItemValue,
  LocationSelectParentProps,
} from "./location-select-parent.type";

import { useTranslation } from "react-i18next";

import { filterAncestorsSelfAndChildren } from "@/entities/ancestor";
import { LOCATIONS_FILTERS } from "@/entities/locations";
import { useOrganizationContextId } from "@/modules/organization/organization-context";
import QueryableSelect from "@/modules/queryable-select";

import LocationSelectOption from "./location-select-parent-option";

const LocationSelectParent = ({
  currentLocationId,
  ...props
}: LocationSelectParentProps) => {
  const { t } = useTranslation();
  const { contextId } = useOrganizationContextId();

  const label = t("global:locationOrSector");

  return (
    <QueryableSelect<
      LocationSelectParentOptionItemValue,
      LocationSelectParentOptionItemData
    >
      withContext
      data-testid="location-select-parent"
      name="location"
      model="locations"
      filterBy="name"
      label={label}
      placeholder={label}
      optionFormat={LocationSelectOption}
      filterCallback={
        currentLocationId
          ? (option) =>
              filterAncestorsSelfAndChildren({
                ancestors: option.ancestors,
                itemType: "location",
                itemId: currentLocationId,
              })
          : undefined
      }
      additionalFilters={
        contextId
          ? { [LOCATIONS_FILTERS.ORGANIZATION_ID]: contextId }
          : undefined
      }
      {...props}
    />
  );
};

export default LocationSelectParent;
